export default {
  name: 'marking--returnType',
};